import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, FileCheck, Server } from 'lucide-react';

const Slide14Compliance = () => {
    return (
        <div className="w-full h-full bg-background p-8 lg:p-16 flex flex-col items-center justify-center relative">
            {/* Background Grid Texture */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)', backgroundSize: '40px 40px' }}
            />
            <motion.div className="text-center mb-16">
                <h2 className="text-4xl lg:text-6xl font-bold mb-4">Compliance-First <span className="text-primary">Architecture</span></h2>
                <p className="text-xl text-muted-foreground">Building trust through regulation.</p>
            </motion.div>

            <div className="relative w-full max-w-5xl">
                {/* Central Timeline Line */}
                <div className="absolute left-0 top-1/2 -translate-y-1/2 w-full h-1 bg-border z-0"></div>

                <div className="grid grid-cols-3 gap-8 relative z-10">

                    {/* Year 1 */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="flex flex-col items-center text-center"
                    >
                        <div className="w-16 h-16 bg-card border border-primary rounded-full flex items-center justify-center mb-6 shadow-lg shadow-primary/10">
                            <FileCheck className="w-8 h-8 text-primary" />
                        </div>
                        <h3 className="text-xl font-bold text-white mb-2">Year 1</h3>
                        <p className="text-sm text-muted-foreground px-4">Non-advisory intelligence with clear disclosures.</p>
                    </motion.div>

                    {/* Year 2 */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4 }}
                        className="flex flex-col items-center text-center"
                    >
                        <div className="w-16 h-16 bg-card border border-muted-foreground rounded-full flex items-center justify-center mb-6 bg-background">
                            <Lock className="w-8 h-8 text-muted-foreground" />
                        </div>
                        <h3 className="text-xl font-bold text-muted-foreground mb-2">Year 2</h3>
                        <p className="text-sm text-muted-foreground px-4">SEBI RIA readiness & comprehensive audit trails.</p>
                    </motion.div>

                    {/* Year 3 */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.6 }}
                        className="flex flex-col items-center text-center"
                    >
                        <div className="w-16 h-16 bg-card border border-dashed border-muted-foreground rounded-full flex items-center justify-center mb-6 bg-background">
                            <Server className="w-8 h-8 text-muted-foreground" />
                        </div>
                        <h3 className="text-xl font-bold text-muted-foreground mb-2">Year 3</h3>
                        <p className="text-sm text-muted-foreground px-4">Regulated execution via Broker Sandbox.</p>
                    </motion.div>

                </div>
            </div>

            {/* Security Badge */}
            <div className="mt-16 flex gap-8">
                <div className="flex items-center gap-2 text-muted-foreground text-sm border px-4 py-2 rounded-full border-border">
                    <Shield className="w-4 h-4 text-green-500" /> VAPT Certified
                </div>
                <div className="flex items-center gap-2 text-muted-foreground text-sm border px-4 py-2 rounded-full border-border">
                    <Lock className="w-4 h-4 text-green-500" /> Explicit Consent Logs
                </div>
            </div>
        </div>
    );
};

export default Slide14Compliance;